import { apiClient } from '../client';

export interface ClaimResponse {
  success: boolean;
  message: string;
  autoApproved: boolean;
  barId?: string;
  requestId?: string;
}

export interface BarMember {
  id: string;
  bar_id: string;
  user_id: string;
  role: 'owner' | 'manager';
  email: string;
  user_name: string | null;
  claimed_at: string | null;
  created_at: string;
}

export interface MembersResponse {
  success: boolean;
  members: BarMember[];
}

export const barMembersApi = {
  claim: async (barId: string): Promise<ClaimResponse> => {
    const { data } = await apiClient.post<ClaimResponse>(`/v1/bars/${barId}/claim`);
    return data;
  },

  getMembers: async (barId: string): Promise<MembersResponse> => {
    const { data } = await apiClient.get<MembersResponse>(`/v1/bars/${barId}/members`);
    return data;
  },

  addMember: async (barId: string, email: string, role: 'owner' | 'manager' = 'manager') => {
    const { data } = await apiClient.post(`/v1/bars/${barId}/members`, { email, role });
    return data;
  },

  updateMember: async (barId: string, memberId: string, role: 'owner' | 'manager') => {
    const { data } = await apiClient.patch(`/v1/bars/${barId}/members/${memberId}`, { role });
    return data;
  },

  removeMember: async (barId: string, memberId: string) => {
    const { data } = await apiClient.delete(`/v1/bars/${barId}/members/${memberId}`);
    return data;
  },
};
